import makeStyles from "@mui/styles/makeStyles";

const useStyle = makeStyles((theme) => ({
  card: {
    backgroundColor: "#FFFFFF",
    boxShadow: "none",
    borderRadius: 8,
    overflow: "hidden",
    border: "none",
    transition: "all 0.2s ease",
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    "&:hover $imgContainer": {
      transform: "scale(1.03)",
    },
  },
  imageContainer: {
    width: "100%",
    height: "200px",
    position: "relative",
    overflow: "hidden",
    borderRadius: 8,
  },
  imgContainer: {
    objectFit: "cover",
    objectPosition: "center",
    transition: "transform 0.3s ease",
    height: "100%",
    width: "100%",
    display: "block",
  },
  // Offer badge - bottom left
  offerBadge: {
    position: "absolute",
    left: 0,
    bottom: "10px",
    backgroundColor: "#FF3008",
    padding: "5px 10px 5px 8px",
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  },
  offerText: {
    color: "#FFFFFF",
    fontSize: "0.72rem",
    fontWeight: 700,
    lineHeight: 1,
  },
  // Heart button - top right on image
  heartBtn: {
    position: "absolute",
    top: 10,
    right: 10,
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.92)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,1)",
    },
  },
  heartIcon: {
    color: "#CC0000",
    fontSize: "16px",
  },
  heartIconOutline: {
    color: "#aaa",
    fontSize: "16px",
  },
  // Content section
  contentContainer: {
    padding: "10px 2px 6px",
  },
  restaurantName: {
    fontWeight: 700,
    fontSize: "0.975rem",
    color: "#191919",
    lineHeight: 1.3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginBottom: 3,
  },
  // Info rows
  infoLine: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    gap: "3px",
    color: "#767676",
    fontSize: "0.8rem",
    lineHeight: 1.4,
  },
  starIcon: {
    color: "#191919",
    fontSize: "13px !important",
  },
  ratingValue: {
    fontWeight: 600,
    color: "#191919",
    fontSize: "0.8rem",
  },
  reviewCount: {
    color: "#767676",
    fontSize: "0.8rem",
  },
  dot: {
    color: "#767676",
    fontSize: "0.8rem",
    margin: "0 1px",
  },
  category: {
    color: "#767676",
    fontSize: "0.8rem",
  },
  metaText: {
    color: "#767676",
    fontSize: "0.8rem",
  },
  // Closed overlay
  closedOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
  },
  closedText: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "0.875rem",
    backgroundColor: "rgba(0,0,0,0.6)",
    padding: "8px 16px",
    borderRadius: 4,
  },
  // Width variants
  largeWidth: {
    width: "100%",
  },
  smallWidth: {
    width: "200px",
    [theme.breakpoints.down("md")]: {
      width: "170px",
    },
  },
  icon: {
    color: "#CC0000",
    fontSize: "16px",
  },
}));

export default useStyle;
